import React from 'react';
import { Star } from 'lucide-react';
export function QuickTestimonials() {
  const testimonials = [{
    quote: 'I was losing clients because my onboarding was a mess. This kit gave me a professional structure overnight. Worth every cent.',
    author: 'Sarah M.',
    role: 'Auckland PT'
  }, {
    quote: 'The consultation scripts alone paid for this 10x over. I finally know how to handle price objections without freezing.',
    author: 'James P.',
    role: 'Christchurch Online PT'
  }, {
    quote: 'I used to spend hours writing programs from scratch. The templates in Volume 4 saved my sanity. Highly recommend.',
    author: 'Rachel T.',
    role: 'Wellington Hybrid Coach'
  }];
  return <section className="bg-[#0A0A0A] py-12 border-y border-nero-border/30" data-id="element-216">
      <div className="max-w-6xl mx-auto px-4" data-id="element-217">
        <div className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar md:grid md:grid-cols-3 gap-6 pb-4 md:pb-0" data-id="element-218">
          {testimonials.map((t, idx) => <div key={idx} className="min-w-[85vw] md:min-w-0 snap-center bg-black border border-nero-border rounded-xl p-6 flex flex-col justify-between" data-id="element-219">
              <div data-id="element-220">
                <div className="flex gap-1 mb-4" data-id="element-221">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-soft-gold text-soft-gold" data-id="element-222" />)}
                </div>
                <p className="text-white text-sm md:text-base italic mb-6" data-id="element-223">
                  "{t.quote}"
                </p>
              </div>
              <div data-id="element-224">
                <p className="text-soft-gold font-bold text-sm" data-id="element-225">{t.author}</p>
                <p className="text-secondary-text text-xs" data-id="element-226">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}